import { Box, CircularProgress } from "@mui/material";
import loadingAnimation from "../Files/loader/loading.json";
import searchDocuments from "../Files/loader/search_docs.json";
import taskLoader from "../Files/loader/Manager.json";
import Lottie from "lottie-react";
import { Button } from "antd";
import { IoMdAddCircleOutline } from "react-icons/io";

const Loader = () => {
  return (
    <div className="container d-flex">
      <div className="dot-falling"></div>
      <div className="dot-falling"></div>
      <div className="dot-falling"></div>
    </div>
  );
};

export default Loader;

export const CustomLoadingOverlay = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1,
        backgroundColor: "rgba(255,255,255,0.7)",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export const OrbitLoader = () => {
  return (
    <div className="flex justify-center min-h-screen">
      <div className="flex row text-center items-center justify-center position-relative">
        <div className="position-absolute text-center flex-auto mb-[120px]">
          <p className="text-them-light-green text-xl font-bold">LeadOrbit</p>
          <span className="text-nowrap text-sm font-semibold">
            fetching & setting up your data...
          </span>
        </div>
        <Lottie
          animationData={loadingAnimation}
          loop={true}
          style={{ height: 250, width: 250 }}
        />
      </div>
    </div>
  );
};

export const SearchDocuments = () => {
  return (
    <div>
      <span className="text-nowrap text-xs text-gray-600 font-bold">
        Uploaded Documents
      </span>
      <Lottie
        className="w-fit mx-auto"
        animationData={searchDocuments}
        loop={true}
        style={{ height: 250, width: 250 }}
      />
      <div className="text-center flex-auto">
        <span className="text-nowrap text-sm text-gray-400 font-bold">
          No documents found for this leads.
        </span>
      </div>
    </div>
  );
};

export const TaskLoader = ({ setOpen }) => {
  return (
    <div className="flex justify-evenly items-center my-auto h-screen">
      <div className="items-center text-center justify-center">
        <Lottie
          className="w-fit mx-auto"
          animationData={taskLoader}
          loop={true}
          style={{ height: 250, width: 250 }}
        />
        <div className="text-center flex-auto">
          <span className="text-nowrap text-xl text-gray-600 font-bold">
            No Task available
          </span>
        </div>
      </div>

      <div className="items-center text-center justify-center">
        <div className="text-wrap text-md text-gray-500 font-bold text-center">
          Task organizer is at your service, be on top of all your due works
        </div>
        <Button
          onClick={() => setOpen(true)}
          startIcon={
            <IoMdAddCircleOutline className="font-extrabold m-0 p-0 mr-1 h-6 lg:h-fit" />
          }
          type="button"
          size="large"
          className="mt-3 font-bold them-btn-default text-transform text-nowrap p-3"
        >
          Add Task
        </Button>
      </div>
    </div>
  );
};

export const OrgTestimonials = ({ setOpen }) => {
  return (
    <div className="flex justify-evenly items-center m-auto">
      <div className="items-center text-center justify-center">
        <Lottie
          className="w-fit mx-auto"
          animationData={taskLoader}
          loop={true}
          style={{ height: 250, width: 250 }}
        />
        <div className="text-center flex-auto">
          <span className="text-nowrap text-xl text-gray-600 font-bold">
            No Data Found!
          </span>
        </div>
      </div>

      <div className="items-center text-center justify-center">
        <div className="text-wrap text-md text-gray-500 font-bold text-center">
          Hurry up! Add Your First Testimonial
        </div>
        <Button
          onClick={() => setOpen(true)}
          startIcon={
            <IoMdAddCircleOutline className="font-extrabold m-0 p-0 mr-1 h-6 lg:h-fit" />
          }
          type="button"
          size="large"
          className="mt-3 font-bold them-btn-default text-transform text-nowrap p-3"
        >
          Add Testimonial
        </Button>
      </div>
    </div>
  );
};
